import { Box, Column, Columns } from "@allxsmith/bestax-bulma";
import React from "react";

export const FiguresSection = props => {
  return (
    <Box>
      <Columns isMultiline>
        {props.figures.map(figure => (
          <Column key={figure.name}>
            {figure.name}: £
            {(props.data[figure.prop] || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </Column>
        ))}
        <Column>
          Total: £
          {props.figures
            .reduce((total, figure) => {
              return (total += props.data[figure.prop]);
            }, 0)
            .toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
        </Column>
      </Columns>
    </Box>
  );
};
